module.exports = __webpack_public_path__ + "assets/icon-dollar-sign-bubble-component.20c14335.svg";